import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { UsuarioClienteBean } from '../shared/model/ajustesUsuario/usuarioClienteBean.model';
import { Observable } from 'rxjs';
import { Cliente } from '../shared/model/ajustesUsuario/cliente.model';

/**
 * Los endpoints de usuarios del portal responden el resultado en
 * codigoError/error del propio bean (00000 = guardado). Un rechazo de
 * negocio (00002: sin la hoja de Clientes, o el usuario o el cliente no son
 * de su empresa) trae ahi el motivo. Devuelve el motivo, o '' si se guardo.
 * Una respuesta vacia tambien es un fallo: el servidor no confirmo nada.
 */
export function motivoDeRechazo(resp: unknown): string {
  const r = resp as { codigoError?: string; error?: string } | null;
  if (r?.codigoError === '00000') {
    return '';
  }
  return r?.error || 'No fue posible guardar el usuario.';
}

@Injectable({
  providedIn: 'root'
})
export class GestionUsuariosService {

  constructor(private httpClient: HttpClient) { }
  
  filtroBusquedaUsuarioCLiente(usuarioCLiente: ConsultaList<UsuarioClienteBean>) {
    return this.httpClient.post<ConsultaList<UsuarioClienteBean>>(UrlConstantes.filtroUsuariosClientes, usuarioCLiente);
  }
  
   actualizaEstUsuaCliente(estatus: UsuarioClienteBean) {
     return this.httpClient.post<UsuarioClienteBean>(UrlConstantes.actualizaEstatusUsCliente, estatus)
   }

   saveUpdateCLient(data: UsuarioClienteBean){
    return this.httpClient.post<UsuarioClienteBean>(UrlConstantes.saveUpdateUsuarios, data);
   }
   
   getClientes(): Observable<ConsultaList<Cliente>>{
     return this.httpClient.get<ConsultaList<Cliente>>(UrlConstantes.consultaClientesCorporativo);
   }

}
